<template>
  <div class="custom-selector">
    <label v-if="label">{{
      /[\u4e00-\u9fa5]/.test(label) ? $t(label) : label
    }}</label>
    <div class="selector-box">
      <!-- @click.stop="isShowSelectorOptions = !isShowSelectorOptions" -->
      <div
        class="selector-carrier"
        ref="selectorRef"
        tabindex="1"
        @focus="selectorFoucsEvent"
        @blur="selectorBlurEvent"
        @click="selectorClickEvent"
      >
        <span>{{ $t(checkedOption.label) }}</span>
        <img
          :src="require('@/assets/images/arrow1.png')"
          :class="{ rotate: isShowSelectorOptions }"
        />
      </div>
      <transition name="fade">
        <div v-show="isShowSelectorOptions" class="selector-options">
          <div
            v-for="item in optionList"
            :key="item.value"
            class="option-item"
            :class="{ active: item.value === checkedOption.value }"
            @click="optionChangeEvent(item)"
          >
            {{
              /[\u4e00-\u9fa5]/.test(item.label) ? $t(item.label) : item.label
            }}
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    optionList: Array,
    label: String,
    value: String,
  },
  data() {
    return {
      isShowSelectorOptions: false,
      focusStatus: 0,
    }
  },
  computed: {
    checkedOption() {
      return this.optionList.find((item) => item.value === this.value)
    },
  },
  methods: {
    optionChangeEvent(item) {
      this.$emit('input', item.value)
    },
    selectorClickEvent() {
      this.focusStatus++
      if (this.focusStatus === 1) {
        this.focusStatus++
        this.isShowSelectorOptions = true
      }
      if (this.focusStatus === 3) {
        this.focusStatus = 0
        this.isShowSelectorOptions = false
      }
    },
    selectorFoucsEvent() {
      this.focusStatus++
      this.isShowSelectorOptions = true
    },
    selectorBlurEvent() {
      this.focusStatus = 0
      this.isShowSelectorOptions = false
    },
  },
}
</script>
<style scoped lang="less">
.custom-selector {
  height: 50px;
  display: flex;
  align-items: center;

  label {
    margin-right: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #99a3b7;
  }
  .selector-box {
    position: relative;
    height: 100%;
    z-index: 999;
    .selector-carrier {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      width: 220px;
      padding-left: 31px;
      padding-right: 25px;
      background: #eef0f3;
      border-radius: 6px;
      cursor: pointer;
      img {
        transition: all 0.3s linear;
        width: 9px;
        height: 6px;
        &.rotate {
          transform: rotate(180deg);
        }
      }
      span {
        font-size: 14px;
        color: #99a3b7;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active 在Vue 2.1.8+ 中 */ {
      opacity: 0;
    }
    .selector-options {
      cursor: pointer;
      position: absolute;
      bottom: -15px;
      width: 160px;
      transform: translateY(100%);
      padding: 6px;
      background: #ffffff;
      border-radius: 6px;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.12),
        0px 4px 5px 0px rgba(0, 0, 0, 0.08),
        0px 1px 10px 0px rgba(0, 0, 0, 0.05);
      .option-item {
        padding-left: 8px;

        height: 32px;
        line-height: 32px;
        // background: #f3f3f3;
        border-radius: 3px;

        font-size: 14px;
        font-weight: 500;
        color: #242b47;
        &:not(:last-child) {
          margin-bottom: 2px;
        }
        &.active {
          background: #e6eaf1;
        }
        &:hover {
          background: #f3f3f3;
        }
      }
    }
  }
}
</style>
